module.exports = __webpack_public_path__ + "static/media/fourth_home.154d0e3a.png";